<template>
	<div id="sidenav-menu">
		<div id="sidenav">
			<div class="topnav">
				<router-link to="/contact" @click="linkTo('toggleEvent')" >
					<a @click="linkTo('toggleEvent')" class="regular-text clickable">
						Kontakt
					</a>
				</router-link>
				<a class="regular-text clickable" @click="login()">
					Anmelden
				</a>
			</div>
			
			<div id="login-warning">
				<hr>
				<p class="regular-text">
					{{loginWarning}}
				</p>				
			</div>
			
			<div id="botNav" class="bottomnav">
				<hr>
				<router-link :to="{ name:'home', params: { newLocation: 'feature'}}" @click="linkTo('toggleEvent');">
					<a class="regular-text clickable" href="#feature" @click="linkTo('toggleEvent'); scroll('feature')"> 
						Features
					</a>
				</router-link>
				<hr>
				<router-link :to="{ name:'home', params: { newLocation: 'product'}}" @click="linkTo('toggleEvent');">
					<a class="regular-text clickable" href="#product" @click="linkTo('toggleEvent'); scroll('product')"> 
						Produkt
					</a>
				</router-link>
				<hr>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: "LandingSidenavMenu",
		data: 
			function(){ 
			return {
				loginWarning: "CIB+ ist nicht für die Darstellung auf einem Smartphone ausgelegt. Bitte verwenden Sie ein Tablet oder Desktop.",
			}
		},
		methods: {
			linkTo(eventName) {
				this.$emit(eventName);
				this.refreshNav();
			},

			scroll(ref) {

				if(ref == "feature") {
				this.$emit('scrollFeature');
				}
				
				if(ref == "product") {
				this.$emit('scrollProduct');
				}
			},

			login() {
				var mediaWidth = window.matchMedia("(min-width: 576px)");
				
				if (mediaWidth.matches) {
					window.open("https://demo.cibplus.de/cibplus-webui", "_blank");
				} else {
					document.getElementById("login-warning").style.display = "block";
					document.getElementById("botNav").style.display = "none";
				}
			},

			refreshNav() {
				document.getElementById("login-warning").style.display = "none";
				document.getElementById("botNav").style.display = "inline-block";
			},

		}
	}
</script>

<style scoped>
	#sidenav {
		position: absolute;
		right: 0;
		top: 0;
		height: 100%;
		background-color: #5f5f5f;
		width: 0px;
		transition: 0.5s;
		color: white;
		background: linear-gradient(90deg, rgba(50,50,50,1) 0%, rgba(98,98,98,1) 10%); 
		left: 0;
		z-index: -1;
	}


	.topnav {
		margin-top: 40px;
		margin-bottom: 30px;
		margin-right: 10px;
		display: block;
		text-align: right;
		white-space: nowrap;
	}

	a {
		color: white;
		text-decoration-line: none;
	}

	.topnav > a {
		padding: 10px;
		font-size: 16px;
	}

	.bottomnav {
		width: 90%;
		display: inline-block;
		text-align: left;
	}
	
	.bottomnav > a > a{
		display: block;
		width: 100%;
		padding: 10px;
	}

	#login-warning {
		display: none;
		padding: 10px;
	}

	#login-warning p {
		width: 90%;
		text-align: left;
		margin: auto;
	}

	@media (min-width: 768px) {
		#sidenav {
			display: none;
			overflow-x: hidden;
		}
	}
</style>

